/*
 * Copyright (c) 2018 Infowijs.
 * Created by Thomas Schoffelen.
 */

function initAccordions () {
  $('.block-accordion h2.accordion-title').click(function () {
    const $h2 = $(this)
    const $el = $h2.parents('.block-accordion').first()
    const id = $el.attr('id')
    if ($el.hasClass('open')) {
      $el.removeClass('open')
    } else {
      $el.addClass('open')
      $el.parents('.block-accordions').first().find('.open:not(#' + id + ')').removeClass('open')
    }
  })
}

$(document).on('pjax:end', initAccordions)
initAccordions()
